import configuration from "./index";
import { authFetch } from "../utils/authFetch";

export const EscalationAPI = {
  getEscalations: async function (query) {
    const response = await authFetch(
      configuration.apiBase + `/library/escalationpolicies?query=${query}`
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error("not ok");
      })
      .catch((error) => {
        console.log(error);
        throw error;
      })
      .then((response) => {
        return response;
      });
    return response.problem;
  },

  getWorkflows: async function (query) {
    const endpoint =
      configuration.apiBase + `/library/workflows?query=${query}`;

    const response = await authFetch(endpoint)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error("not ok");
      })
      .catch((error) => {
        console.log(error);
        throw error;
      })
      .then((response) => {
        return response;
      });
    return response;
  },
};
